/* @flow */

import React from 'react';
import {useSelector} from 'react-redux';

import CompanyDocumentsComponent from 'app/companies/documents';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function CompanyDocumentsPage() {
  const activeCompany = useSelector(state => state.auth.user.activeCompany);

  return (
    <WebsitePageComponent id="company.documents.title" noPaper>
      <CompanyDocumentsComponent key={`company.documents-${activeCompany.id}-${activeCompany.role}`} />
    </WebsitePageComponent>
  );
}
